export const BrushSVG = (props) => (
	<svg
		width={props.width}
		height={props.height}
		viewBox="0 0 300 300"
		xmlns="http://www.w3.org/2000/svg"
	>
	<g id="Layer0_0_FILL">
		<path fill="#361010" fillOpacity="0.30980392156862746" stroke="none" d="
		M 21 300.8
		Q 21.05 300.8 21.05 300.5 20.75 300.5 20.45 300.5 16.65 300.5 12.85 300.5 16.2 301.55 21 300.8 Z"/>

		<path id="brush-tip" fill="#9F051E" fillOpacity="0.9921568627450981" stroke="none" d="
		M 83.15 280.6
		Q 82.85 280.6 82.65 280.7 77.35 283.2 73.2 280 72.9 279.4 72.95 278.85 73.3 270.8 70.85 264.2 70.55 264.2 70.3 264.05 64.85 261.45 56.2 263 55.9 263 55.7 262.9 53.65 261.75 51.5 260.65 51.5 260.35 51.45 260.1 48.95 251.65 50.35 241.9 50.05 241.9 50 241.8 48.7 238.85 45.65 237.8 45.35 237.8 45.1 237.85 40.9 238.3 38.65 240.75 33.5 248.25 31.2 257.9 24 287.95 -1.8 298.75 3.75 301.1 12.25 300.5 12.55 300.5 12.85 300.5 16.65 300.5 20.45 300.5 20.75 300.5 21.05 300.5 59.9 298.6 83 281 83.15 280.85 83.15 280.6 Z"/>

		<path fill="#C0684E" fillOpacity="0.996078431372549" stroke="none" d="
		M 110.95 241.4
		Q 111 241.35 111.3 241.35 111.3 241.05 111.15 240.9 95.75 225.5 80.25 210.25 79.95 210.25 79.65 210.35 51 216.75 38.65 239.55 38.65 239.85 38.65 240.15 38.65 240.45 38.65 240.75 40.9 238.3 45.1 237.85 45.35 237.8 45.65 237.8 48.7 238.85 50 241.8 50.05 241.9 50.35 241.9 48.95 251.65 51.45 260.1 51.5 260.35 51.5 260.65 53.65 261.75 55.7 262.9 55.9 263 56.2 263 64.85 261.45 70.3 264.05 70.55 264.2 70.85 264.2 73.3 270.8 72.95 278.85 72.9 279.4 73.2 280 77.35 283.2 82.65 280.7 82.85 280.6 83.15 280.6 104 268.05 110.95 241.4 Z"/>

		<path fill="#CBD5DC" fillOpacity="0.996078431372549" stroke="none" d="
		M 95.45 179.8
		Q 94.85 179.8 94.4 179.55 93.55 179.1 92.4 179.9 82.4 186.95 76.7 198.55 76.7 198.85 76.7 199.15 76.7 199.45 76.7 199.75 76.7 201.8 76.7 203.85 76.7 204.1 76.7 204.4 77.35 208.15 80.1 209.9 80.25 210 80.25 210.25 95.75 225.5 111.15 240.9 111.3 241.05 111.3 241.35 113.05 242.8 115.4 243.6 115.65 243.65 115.95 243.65 118.3 243.65 120.65 243.65 120.95 243.65 121.25 243.65 132.9 238.65 140.3 229.4 141.8 227.5 140.55 224.9 140.3 224.9 140.15 224.8 118.45 201.65 95.45 179.8 Z"/>

		<path id="brushx" fill="#122B3E" fillOpacity="0.32941176470588235" stroke="none" d="
		M 279.45 35.1
		Q 279.7 35.1 280 35.1
		L 280 34.8
		Q 277.65 34.5 275.35 34.5 275.35 34.8 275.35 35.1 277.4 35.1 279.45 35.1 Z"/>

		<path fill="#996600" stroke="none" d="
		M 275.35 35.1
		Q 272.25 35.55 269.55 36.5 231.05 50.55 200.5 72.6 169.8 94.8 142.75 120.45 115.65 146.1 95.45 178.65 95.45 178.95 95.45 179.2 95.45 179.5 95.45 179.8 118.45 201.65 140.15 224.8 140.3 224.9 140.55 224.9 173.3 204.9 198.9 177.8 224.55 150.7 246.8 120.15 269 89.7 283.95 51.65 288.6 39.8 280 35.1 279.7 35.1 279.45 35.1 277.4 35.1 275.35 35.1 Z"/>
	</g>
  </svg>
)





